import { IconSharing } from '@/common/sharedDefinitions/reportDefinitions.js'

function sortClusters(clusters){
    // Sort alphabetically
    const clusterNames = []
    for (let cluster of clusters) // Get the cluster names for sorting
        clusterNames.push(cluster.Name);
    const indices = [...clusterNames.keys()].sort((a, b) => clusterNames[a].localeCompare(clusterNames[b])); // Sort and return indices
    const sortedClusters = []
    for (let i = 0; i < indices.length; i++){// Apply sorting to cluster list and build sorted list of clusters
        //TODO: cluster ID shouldn't be changed
        clusters[indices[i]].Id = i
        sortedClusters.push(clusters[indices[i]]);
    }
    return sortedClusters
}

function processCluster(clusterObj){
    if (typeof (clusterObj.clusterName) === 'undefined' || typeof (clusterObj.clusterId) === 'undefined')
        throw new Error('The cluster has undefined values');
    if (clusterObj.shareCount > 0 && clusterObj.owned) {
        clusterObj.clusterName += `  ${IconSharing}`
    }
    clusterObj.Ownership = clusterObj.owned ? 'Owned': 'Shared';
    clusterObj.uid = clusterObj.clusterId;
    clusterObj.Name = clusterObj.clusterName;
    clusterObj.accessType = clusterObj.owned ? true: clusterObj.accesstype;
}

function processProject(projectObj){
    if (typeof (projectObj.projectName) === 'undefined' || typeof (projectObj.projectId) === 'undefined')
        throw new Error('The project has undefined values');
    if (projectObj.shareCount > 0 && projectObj.owned) {
        projectObj.projectName += `  ${IconSharing}`
    }
    projectObj.Ownership = projectObj.owned ? 'Owned': 'Shared';
    projectObj.uid = projectObj.projectId;
    projectObj.Name = projectObj.projectName;
    projectObj.accessType = projectObj.owned ? true: projectObj.accesstype;
}

const formatter = {
    formatClusters(responseData){
        responseData.sharedClusters.forEach(shared => { shared.owned = false});
        responseData.clusters.forEach(shared => { shared.owned = true});
        const processedClusters = responseData.clusters.concat(responseData.sharedClusters)
        processedClusters.forEach(cluster => processCluster(cluster))
        const clusterProjectListCache = {}
        const projectObjectAux = {}
        if (typeof (responseData.sharedReports) !== 'undefined') {
            for (const sharedReport of responseData.sharedReports) {
                const clusterId = sharedReport.projectData.clusterData.clusterId
                const projectId = sharedReport.projectData.projectId
                sharedReport.clusterId = clusterId
                if(processedClusters.some(elem => elem.clusterId === clusterId))
                    continue;  // This means they've already shared the whole cluster before
                if (typeof (clusterProjectListCache[clusterId]) === 'undefined') {
                    let clusterName = sharedReport.projectData.clusterData.clusterName
                    if (processedClusters.some(elem => elem.clusterName === clusterName))
                        clusterName = `SR - ${clusterName}`;
                    const clusterElem = {
                        Name: clusterName,
                        uid: clusterId,
                        clusterName: clusterName,
                        clusterId: clusterId,
                        createdAt: sharedReport.projectData.clusterData.createdAt,
                        Ownership: 'Shared',
                        owned: false,
                        accessType: false,
                        projects:[],
                        ownedBy:sharedReport.ownedBy,
                        ownedByName:sharedReport.ownedByName,
                        ownedByUid:sharedReport.ownedByUid,
                    }
                    processedClusters.push(clusterElem)
                    clusterProjectListCache[clusterId] = clusterElem
                }
                if(typeof(projectObjectAux[`${clusterId}_${projectId}`]) === 'undefined'){
                    const projectElem = {
                        Name: sharedReport.projectData.projectName,
                        uid: projectId,
                        projectName: sharedReport.projectData.projectName,
                        Ownership: 'Shared',
                        projectId: projectId,
                        reportCount: 0,
                        shareProjectCount: 0,
                        templateCount: sharedReport.projectData.templateCount,
                        projectCode: sharedReport.projectData.projectCode,
                        owned: false,
                        accessType: false,
                        createdAt: sharedReport.projectData.createdAt,
                        ownedBy:sharedReport.ownedBy,
                        ownedByName:sharedReport.ownedByName,
                        ownedByUid:sharedReport.ownedByUid
                    }
                    clusterProjectListCache[clusterId].projects.push(projectElem);
                    projectObjectAux[`${clusterId}_${projectId}`] = projectElem;
                }
                projectObjectAux[`${clusterId}_${projectId}`].reportCount++;
                projectObjectAux[`${clusterId}_${projectId}`].shareProjectCount++;
            }
        }
        return {
            clusterList: sortClusters(processedClusters),
            clusterProjectListCache: clusterProjectListCache,
            sharedReports: responseData.sharedReports
        }
    },
    formatProjects(responseData){
        responseData.projects.forEach(p => processProject(p))
        return responseData
    }
}

export default formatter
